import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../images/errorIcon.svg";

const ErrorIcon = () => {
  return (
    <Wrapper>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default ErrorIcon;
